import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-orders-list-page',
    templateUrl: './orders-list-page.component.html',
    styleUrls: ['./orders-list-page.component.scss'],
    standalone: false
})
export class OrdersListPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
